import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Typography, Checkbox } from '@mui/material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import { useSelector } from 'react-redux';

export const ContractPayerInfoForm = ({ formik }) => {
  const { seasonYear } = useSelector(state => state.app);
  const fields = [
    { label: 'Nazwa', name: 'contract_payer_name', placeholder: 'nazwa', multiline: true },
    { label: 'Osoba do kontaktu z płatnikiem Umowy', name: 'contract_payer_contact_person', placeholder: '', multiline: true }
  ];

  return (
    <Stack direction="row" justifyContent="center" m={2}>
      <Card sx={{ width: '100%' }}>
        <CardHeader title="Dane Płatnika" sx={{ mt: -1 }} />
        <CardContent>
          <Box
            display="flex"
            flexWrap="wrap"
            gap={2}
            mt={1}
          >
            {seasonYear > 2026 && <Box display="flex" alignItems="center" gap={1} sx={{ minWidth: '300px', flex: '1 1 300px' }}>
              <Typography variant="subtitle2">Użyj danych płatnika</Typography>
              <Checkbox
                id="use_contract_payer_data"
                name="use_contract_payer_data"
                checked={formik.values.use_contract_payer_data}
                onChange={formik.handleChange}
              />
            </Box>}
            {formik.values.use_contract_payer_data && fields.map(({ label, name, placeholder, multiline }) => (
              <Box key={name} display="flex" alignItems="center" gap={1} sx={{ minWidth: '300px', flex: '1 1 300px' }}>
                <Typography variant="subtitle2">{label}</Typography>
                <SmallFormTextField
                  error={formik.errors[name] && formik.touched[name]}
                  name={name}
                  placeholder={placeholder}
                  value={formik.values[name]}
                  onChange={formik.handleChange}
                  helperText={formik.errors[name]}
                  fullWidth
                  multiline={true}
                  rows={2}
                />
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
};
